export default __webpack_public_path__ + "static/media/finances-colored-icon.ab71f374.svg";